import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'
import FloatingNavbar from '../FloatingNavbar'

const Specs = () => {
  return (
    <div>
      <Navbar />
      <FloatingNavbar />
      Specs
      <Footer />
    </div>
  )
}

export default Specs
